import React from 'react';
import './uiPending.scss';

interface StatTileProps {
  label: React.ReactNode;
  value: React.ReactNode;
  sub?: React.ReactNode;
  title?: string;
  /** Extra line under the figure, e.g. a comparison with the earlier period. */
  children?: React.ReactNode;
}

/** One headline figure. Put several in a `.sls-stat-row`. */
const StatTile: React.FC<StatTileProps> = ({ label, value, sub, title, children }) => (
  <div className="sls-stat" title={title}>
    <div className="sls-stat__label">{label}</div>
    <div className="sls-stat__value">{value}</div>
    {sub && <div className="sls-stat__sub">{sub}</div>}
    {children}
  </div>
);

export default StatTile;
